import { render } from "./ResearchItem.vue?vue&type=template&id=5b6fe3ac&scoped=true"
import script from "./ResearchItem.vue?vue&type=script&lang=js"
export * from "./ResearchItem.vue?vue&type=script&lang=js"

import "./ResearchItem.vue?vue&type=style&index=0&id=5b6fe3ac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6fe3ac"]])

export default __exports__